"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.logLevelToSeverityNumber = logLevelToSeverityNumber;
const api_logs_1 = require("@opentelemetry/api-logs");
/**
 * Convert log level to severity number.
 * @internal
 */
function logLevelToSeverityNumber(logLevel) {
    let severityNumber = api_logs_1.SeverityNumber.UNSPECIFIED;
    switch (logLevel) {
        case "ALL":
            severityNumber = api_logs_1.SeverityNumber.UNSPECIFIED;
            break;
        case "DEBUG":
            severityNumber = api_logs_1.SeverityNumber.DEBUG;
            break;
        case "ERROR":
            severityNumber = api_logs_1.SeverityNumber.ERROR;
            break;
        case "INFO":
            severityNumber = api_logs_1.SeverityNumber.INFO;
            break;
        case "VERBOSE":
            severityNumber = api_logs_1.SeverityNumber.TRACE;
            break;
        case "WARN":
            severityNumber = api_logs_1.SeverityNumber.WARN;
            break;
    }
    return severityNumber;
}
//# sourceMappingURL=logUtils.js.map